(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfx-motorsports"] && !Shopify.designMode) return;
  try {
    
(() => {
  const content = {
    car: ['01 / Visibility','Clean placement.<br>Clear recognition.','Doors, rear quarter panels, and approved windshield banners can give BFX a visible place on your build. Every layout is reviewed before production.'],
    content: ['02 / Storytelling','Your build.<br>Our next chapter.','Create real photos and videos, tag BFX, and tell your audience what Bubble Flow Aquatix does. Usage permissions and deliverables are agreed before the partnership begins.'],
    events: ['03 / Community','Bring BFX<br>to the paddock.','Represent the brand at organized events and shows with approved decals, team apparel, or paddock materials. Share the schedule and help us measure the exposure.']
  };
  function mount(root) {
    if (root.dataset.msReady) return;
    root.dataset.msReady = 'true';
    root.querySelectorAll('[data-ms-choice]').forEach(button => button.addEventListener('click', () => {
      const entry = content[button.dataset.msChoice];
      root.querySelectorAll('[data-ms-choice]').forEach(item => item.setAttribute('aria-pressed',String(item===button)));
      root.querySelector('[data-ms-label]').textContent=entry[0];
      root.querySelector('[data-ms-title]').innerHTML=entry[1];
      root.querySelector('[data-ms-copy]').textContent=entry[2];
    }));
    const message=root.querySelector('.ms-message');
    if(message && location.search.includes('contact_posted')) { message.focus(); }
  }
  document.querySelectorAll('.ms-page').forEach(mount);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('.ms-page').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubble-flow-heaters-page"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(container) {
  container.querySelectorAll('[data-heaters-page]').forEach(root => {
   if (root.dataset.ready) return;
   root.dataset.ready = 'true';
   const room = root.querySelector('[data-room]');
   const target = root.querySelector('[data-target]');
   const strings = JSON.parse(root.querySelector('[data-heaters-strings]').textContent);
   function update() {
    const r = Number(room.value), v = Number(target.value), delta = Math.max(0, v-r);
    root.querySelector('[data-room-value]').textContent = r+'°F';
    root.querySelector('[data-target-value]').textContent = v+'°F';
    root.querySelector('[data-temp-display]').innerHTML = v+'<small>°F</small>';
    root.querySelector('[data-c-display]').textContent = ((v-32)*5/9).toFixed(1)+'°C';
    root.querySelector('[data-lift]').textContent = delta ? strings.lift.replace('__VALUE__',delta) : strings.no_lift;
    root.querySelector('[data-cooling]').hidden = r<=v;
   }
   room.addEventListener('input',update); target.addEventListener('input',update); update();
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
